module.exports = __webpack_public_path__ + "img/danti.79d816ff.png";